import { useState, useEffect } from "react";

const useLoadingDots = (isLoading, interval = 500) => {
    const [dotCount, setDotCount] = useState(1);

    useEffect(() => {
        if (!isLoading) {
            setDotCount(1);
            return;
        }
        const timer = setInterval(() => {
            setDotCount((prev) => (prev % 3) + 1);
        }, interval);
        return () => clearInterval(timer);
    }, [isLoading, interval]);

    return ".".repeat(dotCount);
};

export default useLoadingDots;
